import { Component, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";

import { MemberappBaseComponent } from "../memberapp-base/memberapp-base.component";
import {
	MembershipDetails,
	NotifyInfo,
	MemberAppData
} from "../../../shared/models";
import {
	MemberType,
	NotificationStatus
} from "../../../shared/enums/data.enums";
import {
	OrderDetails,
	PaymentDetails,
	PaymentType,
	CardType,
	InstallmentType
} from "@acepteam/payment";
import { environment } from "src/environments/environment.stage";

@Component({
	selector: "app-notify",
	templateUrl: "./notify.component.html",
	styleUrls: ["./notify.component.scss"]
})
export class NotifyComponent extends MemberappBaseComponent {
	notifyInfo: NotifyInfo;
	NotificationStatus: typeof NotificationStatus = NotificationStatus;
	PaymentType: typeof PaymentType = PaymentType;
	CardType: typeof CardType = CardType;
	InstallmentType: typeof InstallmentType = InstallmentType;
	memberAppData: MemberAppData;
	ORG: string = "";
	maskedCCNumber: string = "";
	acepId: string = "";
	orderDetails: OrderDetails;
	paymentInfo: PaymentDetails;
	groupPortalMode: boolean = false;

	ngOnInit() {
		//this.loggerService.logInfo(this.memberAppDataService.memberAppData);
		//reset
		this.resetForm();
	}

	getContentSnippet(KEY: string): string {
		return this.memberAppDataService.getContentSnippet(KEY);
	}

	resetForm() {
		this.isDevEnv = !(environment.production); // this.globalDataOpsService.isTestEnvironment();
		this.ORG = this.globalDataOpsService.ORG;
		this.notifyInfo = this.memberAppDataService.memberAppData.notifyInfo;
		this.memberAppData = this.memberAppDataService.memberAppData;
		this.orderDetails = this.memberAppData.orderDetails;
		this.paymentInfo =
			this.orderDetails == null
				? new PaymentDetails()
				: this.orderDetails.PaymentInformation;
		this.maskedCCNumber = this.helperService.MaskCreditCardNumber(
			this.paymentInfo.CreditCardNumber || this.paymentInfo.ECPAccountDDA
		);
		this.paymentInfo.Amount =
			this.orderDetails == null ? 0 : this.orderDetails.TotalAmount;
		this.acepId = this.ssoService.acepid;
		this.groupPortalMode = this.dataService.IsFromGroupPortal;

		//test
		// this.memberAppData.orderDetails.PaymentInformation.AutoRenewal
		// this.notifyInfo.status = NotificationStatus.RenewalSuccesful;

	}

	getCompSections() {
		let html = '';
		if (this.notifyInfo.status == NotificationStatus.SectionApplication_Comp) {
			let sections = this.memberAppData.sectionDetails.sections.filter(a => a.enabled && a.selected);
			html += `<ul class="sectionlist">`;
			sections.forEach(a => { html += `<li><a target="_blank" href=${a.url}>${a.name}</a></li>` })
			html += `</ul>`;
		}
		console.log(html)
		return html;
	}

	printReceipt() {
		let printlnkDomain = this.globalDataOpsService.BasePath; // this.isTestEnvironment() ? 'https://testwebapps.acep.org' : 'https://webapps.acep.org';
		window.open(
			printlnkDomain +
			"/shoppingcart/printreport.aspx?orderid=" +
			this.memberAppData.orderDetails.OrderId
		);
	}

	goBack() {
		this.location.back();
	}

	goBackSectionApp() {
		window.location.href = `${this.globalDataOpsService.BasePath}/memberapplication/#sectionapp`;
	}

	backToOrg() {

		let url = this.getCMSSite();
		window.location.href = url;
	}

	gotToCustomizeMembership() {
		let url = this.getCMSSite();
		window.location.href = `${url}/customizemembership`;
	}

	getCMSSite() {
		let currentUrl = window.location.href;
		let url = `https://www.${this.ORG}.org`;
		if (currentUrl.indexOf('testwebapps') > -1) {
			url = `https://testwww.${this.ORG}.org`;
		}
		else if (currentUrl.indexOf('devwebapps') > -1 || currentUrl.indexOf('local') > -1) {
			url = `http://devwww.${this.ORG}.org`;
		}

		return url;
	}
}
